import { render, staticRenderFns } from "./other-update.vue?vue&type=template&id=fdc4ac06&scoped=true&"
import script from "./other-update.vue?vue&type=script&lang=js&"
export * from "./other-update.vue?vue&type=script&lang=js&"
import style0 from "./other-update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./other-update.vue?vue&type=style&index=1&id=fdc4ac06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc4ac06",
  null
  
)

export default component.exports